import { render, staticRenderFns } from "./V2RetailerCartList.vue?vue&type=template&id=7bf1e0a2&scoped=true&"
import script from "./V2RetailerCartList.vue?vue&type=script&lang=js&"
export * from "./V2RetailerCartList.vue?vue&type=script&lang=js&"
import style0 from "./V2RetailerCartList.vue?vue&type=style&index=0&id=7bf1e0a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf1e0a2",
  null
  
)

export default component.exports